<div
  class="dropDownListDs__cont dropDownListDs__cont--{{type}}"
  [ngStyle]="{ borderRadius: borderRadius }"
  infiniteScroll
  [scrollWindow]="false"
  [infiniteScrollDisabled]="infiniteScrollDisabled"
  [infiniteScrollDistance]="2"
  (scrolled)="scrolled()">
  <ng-container *ngIf="searchInput">
    <div class="dropDownListDs__search">
      <app-ds-input-search
        [size]="inputSearchSize"
        [autofocus]="true"
        [value]="querySearch"
        [placeholder]="searchInputPlaceholder"
        (changeEvent)="search($event)">
      </app-ds-input-search>
    </div>
  </ng-container>
  <ng-container *ngFor="let option of (viewOptions  | slice : 0 : slice); trackBy: trackById; last as isLast;">
    <div class="dropDownListDs__element">
      <ng-container [ngSwitch]="selectedBy">
        <ng-container *ngSwitchCase="dropDownListSelectedBy.RadioButton">
          <div
            class="dropDownListDs__element--radio"
            [class.selected]="optionIsSelected(option)"
            (click)="selectEvent.emit(option)">
            <app-ds-radio-button
              [title]="getRadioTitle(option)"
              [subtitles]="getRadioSubTitle(option)"
              [icon]="option?.Icon"
              [image]="option?.Image"
              [checked]="optionIsSelected(option)">
            </app-ds-radio-button>
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="dropDownListSelectedBy.Check">
          <div
            class="dropDownListDs__element--check"
            [class.selected]="optionIsSelected(option)"
            (click)="selectEvent.emit(option)">
            <ng-container *ngTemplateOutlet="dropDownListElementByCheck; context: { option: option }"></ng-container>
          </div>
        </ng-container>
      </ng-container>
      <div class="dropDownListDs__divider" [class.hidden]="isLast">
        <app-ds-divider></app-ds-divider>
      </div>
    </div>
  </ng-container>
</div>

<ng-template #dropDownListElementByCheck let-option="option">
  <div class="dropDownListDs__check-item">
    <div class="dropDownListDs__check-item-data">
      <ng-container *ngTemplateOutlet="imageOrIcon; context: { option: option }"></ng-container>
      <div class="dropDownListDs__check-item-data-titles">
        <app-ds-typography
          class="dropDownListDs__check-item-data-title"
          [text]="option?.Title"
          [size]="fontSizeXXS">
        </app-ds-typography>
        <ng-container *ngIf="option?.Subtitle">
          <app-ds-typography
            class="dropDownListDs__check-item-data-subtitle"
            [text]="option?.Subtitle"
            [size]="fontSizeXXS">
          </app-ds-typography>
        </ng-container>
      </div>
    </div>
    <app-ds-icon
      class="dropDownListDs__check-item--checked"
      [class.selected]="optionIsSelected(option)"
      [icon]="check"
      [size]="22">
    </app-ds-icon>
  </div>
</ng-template>

<ng-template #imageOrIcon let-option="option">
  <ng-container *ngTemplateOutlet="option?.Icon ? iconTemplate : imgTemplate; context: { option: option }"></ng-container>
</ng-template>

<ng-template #imgTemplate let-option="option">
  <ng-container *ngIf="option?.Image">
    <div class="dropDownListDs__check-item-data-image">
      <app-ds-image
        [size]="imageSize"
        [objectFit]="'contain'"
        [src]="option?.Image"
        [alt]="option?.Image">
      </app-ds-image>
    </div>
  </ng-container>
</ng-template>

<ng-template #iconTemplate let-option="option">
  <div class="dropDownListDs__check-item-data-icon">
    <app-ds-icon
      [icon]="option?.Icon"
      [size]="22"
      [color]="iconFillColor">
    </app-ds-icon>
  </div>
</ng-template>